import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import List from "@mui/material/List";
import Box from "@mui/system/Box";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { makeStyles } from "@material-ui/core/styles";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { unicodeToString, shuffle, dynamicSort } from "../../../Js/Common";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};
const grid = 8;

const RTS = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  const [rtsContent, setRtsContent] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);
  const [dragged, setDragged] = useState(false);
  const [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      let tempArr = [...props.content.epage.options.content];
      let actualAnswersWithid = tempArr.map((val, index) => {
        let obj = {
          ...val,
          id: index,
        };
        return obj;
      });
      dispatch(currentAssetSliceActions.setCurrentAttemptData(null));

      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: [...actualAnswersWithid],
      });

      setRtsContent(shuffle(actualAnswersWithid));
      setDragged(false);
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    // let tempVar = [...rtsContent];
    // setRtsContent(shuffle(tempVar));
  }, [logObj]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setCurrentAttemptData(null));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    setDragged(false);
    // let tempVar = [...rtsContent];
    // setRtsContent(shuffle(tempVar));
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      let actual = [...rtsContent];
      actual = actual.sort(dynamicSort("id"));
      setRtsContent(actual);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setRtsContent([]);
    };
  }, []);

  useEffect(() => {
    updateUserAnswer();
  }, [rtsContent]);

  const updateUserAnswer = () => {
    if (!showAnswer && !attempted && dragged) {
      dispatch(currentAssetSliceActions.setCurrentAttemptData(rtsContent));
    }
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    boxShadow: isDragging ? "4px 4px 10px 0px #E5E5E5" : "",
    ...draggableStyle,
  });

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination || showAnswer || attempted) {
      return;
    }

    const items = reorder(
      rtsContent,
      result.source.index,
      result.destination.index
    );

    setRtsContent(items);
    setDragged(true);
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <div  >
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {rtsContent &&
                rtsContent.map((item, index) => (
                  <Draggable
                    key={`${index}_id`}
                    draggableId={`${index}_options`}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <Box
                        dense
                        sx={{
                          border: 1,
                          borderColor: "#EFEFEF",
                          padding: 0,
                          my: 2,
                          borderRadius: 10,
                          cursor: "pointer",
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <List dense sx={{ py: 0 }}>
                          <ListItem sx={{ pa: 0 }}>
                            <ListItemIcon>
                              {optionWiseAns && optionWiseAns.length > 0 && (
                                <StatusIndicator
                                  correct={optionWiseAns[index]}
                                ></StatusIndicator>
                              )}
                              {optionWiseAns && optionWiseAns.length == 0 && (
                                <DragIndicatorIcon
                                  sx={{
                                    color: "#EFEFEF",
                                    fontSize: "1.6rem",
                                    "@media (min-width: 1636px)": {
                                      fontSize: "2.4rem",
                                    },
                                  }}
                                />
                              )}
                            </ListItemIcon>
                            {item && item.media && (
                              <OptionMedia
                                media={item.media}
                                isPlaying={currentIndexPlay[index]}
                                setPlayMode={(status, end) => {
                                  setPlayMode(status, index, end);
                                }}
                              ></OptionMedia>
                            )}
                            <ListItemText
                              classes={{ primary: classes.ListItemText }}
                              sx={{ color: "primary.main", pr: 1, py: 0 }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.4rem",
                                  },
                                }}
                              >
                                {unicodeToString(item.text)}
                              </Typography>
                            </ListItemText>
                          </ListItem>
                        </List>
                      </Box>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default RTS;
